/**
 * These are temporary variables and functions to handle expired token access
 * In the future will be updated
 */
let isAuthenticated = false

function logout() {
  if (isAuthenticated) return
  isAuthenticated = true
  alert("Sesi telah berakhir, harap login ulang")
  localStorage.clear()
  window.location.replace('/login')
}

/**
 * @param {RequestInfo} input 
 * @param {RequestInit} requestInit 
 */
export function httpClient(input, requestInit) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(input, requestInit)

      if (response.status === 401 || response.status === 403) {
        logout()
        return
      }

      // other http errors
      if (!response.ok) {
        reject(response)
        return
      }

      resolve(response)
    } catch (error) {
      reject(error)
    }
  })
}
